import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import NationalDashboard from './NationalDashboard';
import AnalystDashboard from './AnalystDashboard';
import KepalaBindaDashboard from './KepalaBindaDashboard';
import AdminBindaDashboard from './AdminBindaDashboard';
import AdministratorNasionalDashboard from './AdministratorNasionalDashboard';
import WakilKepalaBindaDashboard from './WakilKepalaBindaDashboard';
import KoordinatorWilayahDashboard from './KoordinatorWilayahDashboard';
export default function RoleHome() {
  const [role, setRole] = useState(() => localStorage.getItem('bimcs_role') || 'Super Admin Nasional');
  useEffect(() => {
    const handleStorageChange = () => {
      setRole(localStorage.getItem('bimcs_role') || 'Super Admin Nasional');
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);
  switch (role) {
    case 'Analis':
      return <AnalystDashboard data-id="element-3800" />;
    case 'Kepala BINDA':
      return <KepalaBindaDashboard data-id="element-3801" />;
    case 'Wakil Kepala BINDA':
      return <WakilKepalaBindaDashboard data-id="element-3802" />;
    case 'Admin BINDA':
      return <AdminBindaDashboard data-id="element-3803" />;
    case 'Administrator Nasional':
      return <AdministratorNasionalDashboard data-id="element-3804" />;
    case 'Koordinator Wilayah':
      return <KoordinatorWilayahDashboard data-id="element-3805" />;
    // Fullscreen, nav-free experiences live at their own routes so the
    // Layout can strip the sidebar/topbar correctly.
    case 'Operator Command Center':
      return <Navigate to="/command-center" replace data-id="element-3806" />;
    case 'Personel Lapangan':
      return <Navigate to="/mobile" replace data-id="element-3807" />;
    case 'Super Admin Nasional':
    default:
      return <NationalDashboard data-id="element-3808" />;
  }
}